<template>
  <div class="pulseDot" :style="dotStyle"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  size?: number
  color?: string
}>(), {
  size: 12,
  color: 'var(--muted)',
})

const dotStyle = computed(() => ({
  width: `${Math.max(1, Number(props.size || 12))}px`,
  height: `${Math.max(1, Number(props.size || 12))}px`,
  background: String(props.color || 'var(--muted)'),
}))
</script>

<style scoped>
.pulseDot {
  border-radius: 50%;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  flex-shrink: 0;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
